import React, { Component } from "react";
import _ from "lodash";
// Externals
import PropTypes from "prop-types";
import classNames from "classnames";

// Material helpers
import { withStyles } from "@material-ui/core";

// Material components
import InputBase from "@material-ui/core/InputBase";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import CardActions from "@material-ui/core/CardActions";
import IconButton from "@material-ui/core/IconButton";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import Toolbar from "@material-ui/core/Toolbar";

// Icons
import LinkIcon from "@material-ui/icons/Link";
import DeleteIcon from "@material-ui/icons/Delete";
import Extension from "@material-ui/icons/Extension";

// Shared components
import ListIcon from "@material-ui/icons/List";
import ViewGrid from "mdi-material-ui/ViewGrid";

// Shared components
import { IntentEnabled } from "..";

// Component styles
import styles from "./styles";

import { connect } from "react-redux";
import {
  getOauth2ConnectionLink,
  disableConnector,
  clearDisableConnectorResponse,
  generatePublicChatbotSnippet
} from "../../../../redux/actions/connectionActions";
import { pushMessage } from "../../../../redux/actions/commonActions";
import { bindActionCreators } from "redux";
import { openURLInNewWindow } from "../../../../common/utils";
import history from "../../../../history";
import { clearDisableIntentResponse, clearReEnableIntentResponse } from "../../../../redux/actions/intentsActions";
import { withRouter } from "react-router-dom";
import Highlight from "react-highlight";

import "../../../../../node_modules/highlight.js/styles/tomorrow-night-bright.css";
import DisableConnectorDialog from "../../../Connections/components/ConnectionDialog/disableConnectorDialog";
import EmbedConnectorDialog from "../../../Connections/components/ConnectionDialog/embedConnectorDialog";

// TODO: check what is this used for, and delete it??
const BootstrapInput = withStyles(theme => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(3)
    }
  },
  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.background.light,
    // border: '1px solid #ced4da',
    fontSize: 16,
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:focus": {
      borderRadius: 4,
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)"
    }
  }
}))(InputBase);

class IntentsEnabledList extends Component {
  state = {
    listBtnClass: "viewIconSelected",
    gridBtnClass: "viewIcon",
    view: "list", // or 'grid'
    disableConnectorBtnDisabled: !this.props.administrator,
    deletePromptOpened: false,
    embedPromptOpened: false
  };

  componentDidMount() {
    if (!this.props.connectorName) {
      this.props.history.push("/manage-connections");
    }
  }

  componentWillUnmount() {
    const { clearDisableConnectorResponse, clearDisableIntentResponse, clearReEnableIntentResponse } = this.props;

    clearDisableConnectorResponse();
    clearDisableIntentResponse();
    clearReEnableIntentResponse();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { disableConnectorResponse, disableIntentResponse, reEnableIntentResponse } = this.props;

    // Check if component received API response after disabling a connector
    if (disableConnectorResponse && prevProps.disableConnectorResponse !== this.props.disableConnectorResponse) {
      this.handleConnectorDisabledResponse(disableConnectorResponse);
    }

    // Check if component received API response after disabling an intent
    if (disableIntentResponse && prevProps.disableIntentResponse !== this.props.disableIntentResponse) {
      this.handleDisableIntentResponse(disableIntentResponse);
    }

    // Check if component received API response after re-enabling an intent
    if (reEnableIntentResponse && prevProps.reEnableIntentResponse !== this.props.reEnableIntentResponse) {
      this.handleReEnableIntentResponse(reEnableIntentResponse);
    }
  }

  handleConnectorDisabledResponse = apiResponse => {
    const { clearDisableConnectorResponse, pushMessage } = this.props;
    clearDisableConnectorResponse();
    console.log(apiResponse);
    if (apiResponse.code === 200) {
      pushMessage({
        message: "Connector successfully disabled, you will be redirected to the connectors page shortly",
        type: "success"
      });

      setTimeout(() => history.push("/manage-connections"), 5000);
    } else if (apiResponse.code === 403) {
      this.setState({ disableConnectorBtnDisabled: false });
      pushMessage({
        message: "Insufficient permissions for delete action. Contact you administrator for more information.",
        type: "error"
      });
    } else {
      this.setState({ disableConnectorBtnDisabled: false });

      pushMessage({
        message: "Could not disable connector, please try again later",
        type: "error"
      });
    }
  };

  handleDisableIntentResponse = apiResponse => {
    const { clearDisableIntentResponse, pushMessage, getConnection } = this.props;
    clearDisableIntentResponse();

    if (apiResponse.code === 200) {
      pushMessage({
        message: "Intent successfully disabled",
        type: "success"
      });
    } else {
      pushMessage({
        message: "Could not disable intent, please try again later",
        type: "error"
      });
    }

    getConnection();
  };

  handleReEnableIntentResponse = apiResponse => {
    const { clearReEnableIntentResponse, pushMessage, getConnection } = this.props;
    clearReEnableIntentResponse();

    if (apiResponse.code === 200) {
      let message;
      if (apiResponse.message.includes("Inserted")) {
        message = "Intent successfully enabled";
      } else {
        message = "Intent successfully re-enabled";
      }

      pushMessage({
        message: message,
        type: "success"
      });
    } else {
      pushMessage({
        message: "Could not re-enable intent, please try again later",
        type: "error"
      });
    }

    getConnection();
  };

  /**
   * Filter intents by selected connector and, optionally, by value of input for searching intents.
   */
  filteredIntents = () => {
    const { searchTerm } = this.props;
    const lowercaseSearchTerm = searchTerm.toLowerCase();

    return _.filter(this.props.intents, intent => {
      if (searchTerm && searchTerm.length) {
        // Check if searched term matches intent title or name
        if (
          _.includes(intent.title.toLowerCase(), lowercaseSearchTerm) ||
          _.includes(intent.name.toLowerCase(), lowercaseSearchTerm)
        ) {
          return true;
        }
      } else {
        return true;
      }
      return false;
    });
  };

  renderIntents(filteredIntents) {
    if (filteredIntents.length === 0) {
      return <Typography variant="h6">There are no task available</Typography>;
    }

    const { onIntentClick } = this.props;

    return (
      <React.Fragment>
        {filteredIntents.map(intent => (
          <React.Fragment key={intent.ID}>
            <IntentEnabled intent={intent} onIntentClick={onIntentClick} view={this.state.view} />
          </React.Fragment>
        ))}
      </React.Fragment>
    );
  }

  handleListIconClick = () => {
    this.setState({ view: "list" });
  };

  handleGridIconClick = () => {
    this.setState({ view: "grid" });
  };

  openDeletePromptWindow = () => {
    this.setState({ deletePromptOpened: true });
  };

  openEmbedPromptWindow = async () => {
    // make redux action call to get bot properties
    await this.props.generatePublicChatbotSnippet();
    this.setState({ embedPromptOpened: true });
  };

  handleDelete = () => {
    this.handleDisableConnector();
  };

  handleCancelDelete = () => {
    this.setState({ deletePromptOpened: false });
  };

  handleCancelEmbed = () => {
    this.setState({ embedPromptOpened: false });
  };

  handleLinkConnector = async () => {
    localStorage.setItem("ConnectionId", this.props.connectorName);
    // enable
    await this.props.getOauth2ConnectionLink(this.props.connectorName);
    if (this.props.connections.latestOAuthRedirectLink.createConnectionStatus !== 200) {
      this.props.pushMessage({
        message: "Error in generating redirect link.",
        type: "error"
      });
    } else {
      openURLInNewWindow(this.props.connections.latestOAuthRedirectLink.oauthRedirectUrl);
    }
  };

  handleDisableConnector = () => {
    const { pushMessage, currentConnection } = this.props;

    this.setState({ disableConnectorBtnDisabled: true, deletePromptOpened: false });

    pushMessage({
      message: "Disabling connector and all related tasks",
      type: "info"
    });

    // Check if there's info about current connection

    if (!currentConnection) {
      this.setState({ disableConnectorBtnDisabled: false });

      return pushMessage({
        message: "Could not load selected connector",
        type: "error"
      });
    }

    console.log("Disabling connector");
    this.props.disableConnector(currentConnection);
  };

  render() {
    const { classes, className, displayName, connectorName } = this.props;
    console.log("Display name", this.props);
    const rootClassName = classNames(classes.root, className);
    const filteredIntents = this.filteredIntents();

    let listBtnClass = "viewIconSelected";
    let gridBtnClass = "viewIcon";

    if (this.state.view === "grid") {
      listBtnClass = "viewIcon";
      gridBtnClass = "viewIconSelected";
    }

    return (
      <Grid container spacing={2}>
        <Grid item xs={12} className={classes.titleContainer}>
          <Typography variant="h3" className={classes.title}>
            Tasks for {displayName ? displayName : connectorName}
          </Typography>
        </Grid>
        <Grid item xs={12} className={classes.titleContainer}>
          <Typography className={classes.numberOfIntents}>
            {filteredIntents.filter(intent => !_.get(intent, "deleted", false)).length} enabled |
          </Typography>
          <Typography className={classes.numberOfIntents}>
            &nbsp;
            {filteredIntents.filter(intent => _.get(intent, "deleted", false)).length}
            {filteredIntents.filter(intent => _.get(intent, "deleted", false)).length === 1 && " disabled intent"}
            {filteredIntents.filter(intent => _.get(intent, "deleted", false)).length > 1 && " disabled intents"}
            {filteredIntents.filter(intent => _.get(intent, "deleted", false)).length === 0 && " disabled intents"}
          </Typography>
          <Toolbar>
            {this.props.connectorType !== "public-rest-api" && (
              <Tooltip title={"Link Connection"}>
                <IconButton
                  variant="contained"
                  color="primary"
                  // disabled={_.get(this.props.currentConnection, "auth_exists", false)}
                  className={classes.button}
                  onClick={this.handleLinkConnector}
                >
                  <LinkIcon /> 
                </IconButton>
              </Tooltip>
            )}
            <Tooltip
              title={this.props.botBuildTriggered ? "Action disabled. Building in progress." : "Disable Connection"}
            >
              <span>
                <IconButton
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  onClick={this.openDeletePromptWindow}
                  disabled={this.state.disableConnectorBtnDisabled || this.props.botBuildTriggered}
                >
                  <DeleteIcon />
                </IconButton>
              </span>
            </Tooltip>
          </Toolbar>
        </Grid>
        <Grid item xs={12} className={classes.changeView}>
          <IconButton
            id="listBtn"
            onClick={this.handleListIconClick}
            className={classes[listBtnClass]}
            aria-label="List view"
          >
            <ListIcon />
          </IconButton>
          <IconButton onClick={this.handleGridIconClick} className={classes[gridBtnClass]} aria-label="grid view">
            <ViewGrid />
          </IconButton>
        </Grid>

        <DisableConnectorDialog
          open={this.state.deletePromptOpened}
          currentConnection={this.props.currentConnection}
          closeDisableConnectorDialog={this.handleCancelDelete}
          confirmDisableConnectorDialog={this.handleDelete}
        />

        <EmbedConnectorDialog
          open={this.state.embedPromptOpened}
          publicChatbotProps={this.props.publicChatbotProps}
          handleCancelEmbed={this.handleCancelEmbed}
        />

        <CardActions className={classes.listHeader} />
        <div className={classes.connectionsContainer}>
          <List dense={true} className={classes.list}>
            {this.renderIntents(filteredIntents)}
          </List>
        </div>
      </Grid>
    );
  }
}

IntentsEnabledList.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  intents: PropTypes.array.isRequired,
  onIntentClick: PropTypes.func.isRequired,
  history: PropTypes.object,
  connectorName: PropTypes.string
};

function mapStateToProps(state) {
  return {
    currentConnection: state.connections["connection"] ? state.connections["connection"] : {},
    publicChatbotProps: state.connections["publicChatbotProps"] ? state.connections["publicChatbotProps"] : {},
    connections: state.connections,
    disableConnectorResponse: state.connections.disableConnectorResponse,
    disableIntentResponse: state.intents.disableIntentResponse,
    reEnableIntentResponse: state.intents.reEnableIntentResponse,
    administrator: _.get(state.auth.cognitoUser.attributes, "custom:role", "user") === "Administrator",
    botBuildTriggered: state.intents["botBuildTriggered"] ? state.intents.botBuildTriggered : false
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        getOauth2ConnectionLink,
        disableConnector,
        clearDisableConnectorResponse,
        clearDisableIntentResponse,
        clearReEnableIntentResponse,
        generatePublicChatbotSnippet,
        pushMessage
      },
      dispatch
    ),
    dispatch
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(styles)(IntentsEnabledList))
);
